// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import IconCalendar from '@plumberssupply/XDL/Icons/IconCalendar';
import { css } from "styled-components";

const DatePickerPresentationPropsDefault: ComponentThemeProps["datePicker"]["defaultProps"] = {
    calendarIconProps: {
        color: "text.main",
        css: css`
            margin-right: -9px;
            svg {
                width: 14px;
                height: 14px;
                margin-left: auto;
            }
        `,
        src: IconCalendar,
    },
    clearIconProps: {
        color: "text.main",
        src: "X",
        css: css`
            svg {
                width: 14px;
                height: 14px;
                margin-left: auto;
            }
        `,
    },
    cssOverrides: {
        formField: css`
            width: unset;
        `,
    },
    dateTimePickerProps: {
        calendarType: "US",
        showLeadingZeros: true,
        showFixedNumberOfWeeks: false,
        showNeighboringMonth: false,
    },
    format: "MM/dd/y",
    placeholders: {
        dayPlaceholder: "dd",
        monthPlaceholder: "mm",
        yearPlaceholder: "yyyy",
        hourPlaceholder: "hr",
        minutePlaceholder: "min",
    },
};

export default DatePickerPresentationPropsDefault;
